<template>
	<div class="table_div">
		<el-form :inline="true" class="select_form">
			<el-form-item>
				<h3>结果公示</h3>
			</el-form-item>
			<el-form-item>
				<el-input v-model="infoData.year" placeholder="请输入评价年度" clearable @clear='getTableData'></el-input>
			</el-form-item>
			<el-form-item>
				<el-input v-model="infoData.regionName" placeholder="请输入评价区域" clearable @clear='getTableData'>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-input v-model="infoData.companyName" placeholder="请输入参评单位名称" clearable @clear='getTableData'>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-input v-model="infoData.orgCode" placeholder="请输入信用代码" clearable @clear='getTableData'>
					<template #append>
						<el-button icon="Search" @click="getTableData" />
					</template>
				</el-input>
			</el-form-item>
		</el-form>
		<el-table :data="infoData.tableData"  stripe border
			 table-layout="fixed" v-loading='infoData.loading' height='86%'  @select="handleSelect" ref='tableData'  highlight-current-row
			@current-change="handleTableChange">
			<el-table-column type="selection" width="55" />
			<el-table-column prop="companyName" label="单位名称" sortable/>
			<el-table-column prop="yearNum" label="评价年度" sortable/>
			<el-table-column label="评价区域">
				<template #default="scope">
					{{scope.row.regionName + '/'+ scope.row.cityName  + '/'+ scope.row.countiesName}}
				</template>
			</el-table-column>
			<el-table-column prop="orgCode" label="社会信用代码" width='200'  />
			<el-table-column prop="methonNumber" label="评价标准" width='300' />
			<el-table-column prop="score" label="评价分数" sortable/>
			<el-table-column prop="scoreLevel" label="评价结果" sortable/>
			<el-table-column prop="pType" label="公示" />
			<el-table-column prop="unitName" label="评价单位" />
		</el-table>

		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="infoData.pageInfo.pageIndex" :page-sizes="[20, 50, 100,200,500,1000]" :page-size="infoData.pageInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="infoData.pageInfo.totalRowCount"
			v-if='infoData.pageInfo.totalRowCount' class='pageinfo'>
		</el-pagination>
	</div>
</template>

<script>
	import {
		onMounted,
		reactive,
		ref
	} from "vue-demi";
	import api from "../../http/apis";
	import {
		ElMessageBox,
		ElMessage
	} from "element-plus";
	import {
		useStore
	} from "vuex";
	import {
		Search
	} from '@element-plus/icons-vue'
	export default {
		setup() {
			const store = useStore();
			const tableData = ref(null);
			const infoData = reactive({
				tableData: [],
				loading: false,
				pageInfo: {},
				seletectRoleInfo: {},
				searchInput: '',
				regionName: '',
				shengping: '',
				companyName: '',
				orgCode: '',
				yearNum: 0,
				year: ''
			});
			const getTableData = async () => {
				infoData.loading = true
				if (infoData.year) {
					infoData.yearNum = parseInt(infoData.year)
				} else {
					infoData.yearNum = 0
				}
				const {
					data
				} = await api.companyApi.queryECAAppraise({
					page: infoData.pageInfo.pageIndex || 1,
					rows: infoData.pageInfo.pageSize || 20,
					Value: infoData.searchInput,
					yearNum: infoData.yearNum,
					order: 'desc',
					regionName: infoData.regionName,
					shengping: infoData.shengping,
					companyName: infoData.companyName,
					orgCode: infoData.orgCode,
					sort:"",
				});
				if (data.isSuccessful) {
					infoData.loading = false
					infoData.tableData = data.resultObj.data
					infoData.pageInfo = data.resultObj.pagerInfo
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			};
			getTableData()
			const handleSelect = (selection, row) => {
				if (selection.length > 1) {
					tableData.value.toggleRowSelection(selection[0], false)
					tableData.value.setCurrentRow(row)
				} else if (selection.length == 1) {
					// console.log(selection.length)
					tableData.value.setCurrentRow(row)
				} else if (selection == '') {
					tableData.value.toggleRowSelection(row, true)
				} else {}
			};
			const handleTableChange = (currentRow, oldCurrentRow) => {
				if (oldCurrentRow) {
					tableData.value.toggleRowSelection(oldCurrentRow, false)
					handleSelect('', currentRow)
				} else {
					handleSelect('', currentRow)
				}
			
			};
			return {
				infoData,
				getTableData,
				handleSelect,
				handleTableChange,
				tableData
			};
		},
		methods: {
			async checkRoleDifined() {
				if (!this.infoData.seletectRoleInfo.id) {
					ElMessage({
						message: '请选择用户后再进行操作！',
						type: "error",
					});
				} else {
					this.$router.push({
						path: "userRole",
						query: {
							id: this.infoData.seletectRoleInfo.id,
						},
					});
				}
			},
			handleSizeChange(val) {
				this.infoData.pageInfo.pageSize = val;
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.infoData.pageInfo.pageIndex = val;
				this.getTableData();
			},
			handleTableCurrentChange(val) {
				this.infoData.seletectRoleInfo = val
			},
			dateTrimmer(str) {
				if (str) {
					return str.slice(0, 10) + " " + str.slice(11, 19);
				} else {
					return "无";
				}
			},
			handleClose() {
				this.infoData.dialogVisible = false
				this.infoData.role = ''
			},
		},
	};
</script>

<style scoped lang='scss'>
	@use "../../assets/scss/table.scss"as *;
</style>
